import React, { Component } from 'react';
import { number, oneOf, bool, element, object, string } from 'prop-types';
import { motion, AnimatePresence } from "framer-motion";

class CollapseColumn extends Component {
  static propTypes = {
    width: number,
    direction: oneOf(['left', 'right']),
    show: bool,
    children: element,
    style: object,
    className: string
  };

  static defaultProps = {
    width: 300,
    direction: 'left',
    show: true,
    style: {},
    className: ''
  };

  render() {
    const marginDirection = this.props.direction === 'left' ? 'marginLeft' : 'marginRight';
    const { width, show, children } = this.props;

    const base = {
      [marginDirection]: `${-1 * width}px`,
      width: `${width}px`
    };
    const appear = {
      [marginDirection]: 0
    };
    const enter = {
      [marginDirection]: 0,
      transition: 'all 200ms ease-out'
    };
    const leave = {
      [marginDirection]: `${-1 * width}px`,
      transition: 'all 200ms ease-out'
    };
    return (
      <AnimatePresence>
        {show && (
          <motion.div
            base={base}
            appear={appear}
            enter={enter}
            leave={leave}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    );
  }
}

export default CollapseColumn;
